import React from 'react';
import { inBrowser } from '@firefly/fly-defter';
import { createUpdateEffect } from "./createUpdateEffect";
export var useIsomorphicLayoutEffect = inBrowser ? React.useLayoutEffect : React.useEffect;
export var useIsomorphicUpdateLayoutEffect = createUpdateEffect(useIsomorphicLayoutEffect);
export default useIsomorphicLayoutEffect;